<template>
    <div class="noContent">
        <img src="~@img/xueyezixun/public/no_content3.png" alt="">
      <div style="font-size: 18px;text-align: center;color:#333">暂无消息</div>
    </div>
</template>

<script>
export default {
    name: "noContent",
    props: {
        type: {
            type: String,
            default: 'btnBlue'
        },
        name: String,
    },
    methods: {
        handleClick(){
            this.$emit('handleClick')
        }

    }

}
</script>

<style scoped lang="less">
.noContent {
    img {
        display: block;
        margin: 0 auto;
    }
}
</style>